<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="row mx-0 mb-24 u-flex--vertical-end">
            <div class="col-12 col-md px-0 mb-18 mb-0@md">
                <h2 class="u-text-normal mb-12">
                    Dashboard <span class="text-light">({{ documents.length }})</span>
                </h2>
                <small class="u-block mb-12">Hier landen neue Dokumente. Archiviere sie, sobald du sie mit Namen, Datum und Tags versehen hast.</small>

                <div class="row px-12">
                    <app-button icon="plus" class="col-12 col-md mr-0 mr-6@md mb-3 mb-0@md" size="small" @click.native="showAddModal = true">Einzel-Upload</app-button>
                    <app-button icon="plus" class="col-12 col-md mr-0 mr-6@md mb-3 mb-0@md" size="small" @click.native="$router.push({ name: 'MultiUpload' })">Multi-Upload</app-button>
                    <app-button
                        class="col-12 col-md mb-3 mb-0@md"
                        icon="cloud-upload"
                        theme="highlight"
                        title="Empfange Dokumente via Mail oder Cloud"
                        size="small"
                        @click.native.stop="showSendDocumentModal = true"
                    />
                </div>
            </div>
            <div v-if="documents.length" class="col-12 col-md">
                <div class="sort">
                    <div class="row u-flex--vertical-align">
                        <label for="sortBy" class="u-bold col mb-0 p-0 pr-12@md">Sortierung:</label>
                        <div class="col-8 p-0">
                            <select v-model="sortBy" id="sortBy" class="form-control" style="height: 40px;">
                                <option value="updated_desc">Letzte Änderung (absteigend)</option>
                                <option value="date_asc">Ausstelldatum (aufsteigend)</option>
                                <option value="date_desc">Ausstelldatum (absteigend)</option>
                                <option value="name_asc">Titel (A-Z)</option>
                                <option value="name_desc">Titel (Z-A)</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading-overlay :active="isLoading">
            <div v-if="documents.length" class="u-flex u-flex-wrap pb-24">
                <document-thumb
                    v-for="document in sortedItems"
                    :key="document.id"
                    v-bind="document"
                    show-archive
                    @delete="onDeleteDocument"
                    @reload="loadDocuments"
                />
            </div>
            <div v-else-if="!isLoading" class="u-flex u-flex--center u-flex-grow pt-56">
                <div class="u-text-center">
                    <app-icon name="thumbsup" :scale="4" hidden class="mb-12"/>
                    <p class="text-mute">Hier gibt es gerade nichts zu tun.</p>
                </div>
            </div>
        </loading-overlay>

        <send-document-modal
            v-model="showSendDocumentModal"
            headline="Dokumente empfangen"
            @reload="loadDocuments"
        />

        <add-document-modal
            v-if="showAddModal"
            v-model="showAddModal"
            document-status="draft"
            @add="onAddDocument"
        />
    </div>
</template>

<script>
import { sortItems } from '@/assets/documents'
import AppIcon from '@/components/ui/Icon.vue'
import Button from '@/components/ui/Button.vue'
import DocumentThumb from '@/components/DocumentThumb.vue'
import SendDocumentModal from '@/components/ui/modals/SendDocumentModal.vue'
import AddDocumentModal from '@/components/ui/modals/AddDocumentModal.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
    name: 'Home',

    components: { LoadingOverlay, AddDocumentModal, SendDocumentModal, DocumentThumb, AppIcon, AppButton: Button },

    data () {
        return {
            documents: [],
            showSendDocumentModal: false,
            showAddModal: false,
            sortBy: 'updated_desc',
            isLoading: false,
        }
    },

    computed: {
        sortedItems () {
            return sortItems(this.documents, this.sortBy)
        },
    },

    mounted () {
        this.loadDocuments()
    },

    methods: {
        async loadDocuments () {
            this.isLoading = true

            try {
                const response = await this.$http.get('/document-drafts')
                this.documents = response.data
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                setTimeout(() => {
                    this.isLoading = false
                }, 1000)
            }
        },

        onDeleteDocument (documentId) {
            const index = this.documents.findIndex(x => x.id === documentId)
            this.documents.splice(index, 1)
        },

        onAddDocument (document) {
            this.showAddModal = false
            this.documents.unshift(document)
        },
    },
}
</script>

<style lang="scss" scoped>
.sort {
    margin: auto 0 auto auto;

    @include media-breakpoint-up(md) {
        text-align: right;

        .row {
            justify-content: flex-end;
        }
    }
}
</style>
